import React, { useState } from "react";
import * as Yup from "yup";
import { TEXT, DATE_TIME, CURRENCY, INTEGER, TEXT_DISABLED, TEXT_AREA } from "../../../components/form/VinSystemsFormBuilderFieldTypes";
import { useSelector } from "react-redux";
import GenericAppFormBuilder from "../GenericApp/GenericAppFormBuilder";
import PropTypes from "prop-types";

const FormValidation = Yup.object().shape({
  name: Yup.string().required("Required"),
});

const formObj = {
  name:'sms-history-app-form',
  validation: FormValidation,
  isReadOnly: true,
  groups: [
    {
      title: 'User',
      subTitle: '',
      fields: [
        { name: 'userName', label: 'User Name', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'userId', label: 'User Id', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'userOauthId', label: 'User Oauth Id', type: TEXT_DISABLED, fieldProps: {} },
      ]
    },
    {
      title: 'Main',
      subTitle: '',
      fields: [
        { name: 'sent', label: 'Sent', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'status', label: 'Status', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'message', label: 'Message', type: TEXT_AREA, fieldProps: { gridSize: 12 , disabled: true} },
        { name: 'phoneNumbers', label: 'Phone Numbers', type: TEXT_AREA, fieldProps: { gridSize: 12 , disabled: true} },
        { name: 'requestData', label: 'Request Data', type: TEXT_AREA, fieldProps: { gridSize: 12 , disabled: true} },
        { name: 'responseData', label: 'Response Data', type: TEXT_AREA, fieldProps: { gridSize: 12 , disabled: true} },
      ]
    },
    {
      title: 'Info',
      fields: [
        { name: 'createdDate', label: 'Created', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'modifiedDate', label: 'Modified', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'deletedDate', label: 'Deleted', type: TEXT_DISABLED, fieldProps: {} },
        { name: 'tenantId', label: 'Tenant ID', type: TEXT_DISABLED, fieldProps: {} },
      ]
    }
  ],
  record: null
}

// public string UserId { get; set; }
// public string UserName { get; set; }
// public string UserOauthId { get; set; }
//
// public string Message { get; set; }
// public string PhoneNumbers { get; set; }
// public string RequestData { get; set; }
// public string ResponseData { get; set; }
// public bool Sent { get; set; } = false;
// public string Status { get; set; }
// public long TenantId { get; set; }
// public string TenantContext { get; set; }

const SmsHistoryAppForm = (props) => {
  const { currentRecord } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const [obj, setObj] = useState( currentRecord);

  // const handleExtraFields = (formik) => {
  //   return(
  //     <FormikFileUploadField formik={formik} fieldName={'slug'} isPreviewOnly={true} isPublic={false} label={'Slug'}/>
  //   )
  // }

  return (
    <GenericAppFormBuilder  currentRecord={obj} formObj={formObj} onSubmit={props.onSubmit} />
  )
}

SmsHistoryAppForm.propTypes = {
  onSubmit: PropTypes.func
}

export default SmsHistoryAppForm;
